import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "antd/dist/antd.css";

import { LocaleProvider } from "antd";
import pt_BR from "antd/lib/locale-provider/pt_BR";
import "moment/locale/pt-br";
import numeral from 'numeral';
import "numeral/locales/pt-br";

import MainLayout from "./layouts/MainLayout";

numeral.locale('pt-br');

class App extends Component {
  render() {
    return (
      <Router>
        <LocaleProvider locale={pt_BR}>
          <MainLayout />
        </LocaleProvider>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js